import React from 'react'
import { Component } from 'react'
import { IBetterSelectItemProps, IBetterSelectItemState, IBetterSelectOption } from './interfaces'

export class BetterSelectItem extends Component<IBetterSelectItemProps, IBetterSelectItemState> {
    public constructor(props: IBetterSelectItemProps) {
        super(props)
    }

    public render(): React.ReactNode {
        const handleClick = this.handleClick.bind(this)
        const label = this.props.label || this.props.value

        const classNames: string[] = ['bsl-dropdown-option']
        if (!!this.props.checked) {
            classNames.push('bsl-selected')
        }
        if (!!this.props.disabled) {
            classNames.push('disabled')
        }

        if (this.props.renderOptionItem) {
            return this.props.renderOptionItem(this.buildItemPackage(), !!this.props.checked, handleClick)
        }

        return (
            <div className={classNames.join(' ')} onClick={handleClick}>
                <span className="bsl-dropdown-option-label">
                    <span>{label}</span>
                </span>
                <span className="bsl-dropdown-option-toggle">
                    <input
                        type="checkbox"
                        checked={true}
                        readOnly={true}
                        tabIndex={-1}
                        disabled={this.props.disabled}
                    />
                </span>
            </div>
        )
    }

    protected handleClick(): void {
        this.props.onChange(this.buildItemPackage(), !this.props.checked)
    }

    private buildItemPackage(): IBetterSelectOption {
        return {
            value: this.props.value,
            label: this.props.label,
        }
    }
}
